<template>
	<ui-modal @toggle="$emit('toggle')">
		<div class="flex flex-col gap-2" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="text-slate-700">
				<template v-slot:text>
					<p>Filtres</p>
				</template>
			</ui-title>
			<form @submit.prevent="doSearch" class="flex flex-col gap-2">
				<form-input placeholder="Nom" v-model="form.name" @keyup.enter="doSearch"></form-input>
				<form-input placeholder="Slug" v-model="form.slug" @keyup.enter="doSearch"></form-input>
				<form-select
					:items="types"
					placeholder="Type"
					@valueChange="form.type = $event"
					:value="form.type"
					@keyup.enter="doSearch"></form-select>
				<ui-button type="submit" @click="doSearch" class="mt-3 font-bold border-2" position="center">
					<template v-slot:text>Rechercher</template>
				</ui-button>
			</form>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';

	const page = usePage();

	const props = defineProps({
		searchForm: {
			type: Object,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const searchResult = ref([]);
	const types = ref([]);

	const form = ref({
		name: null,
		slug: null,
		type: null,
	});

	const doSearch = () => {
		loading.value = true;
		router.get(route('admin.statuses'), {
			params: form.value,
		});
	};

	onMounted(() => {
		if (Object.keys(props.searchForm).length > 0) {
			form.value = { ...props.searchForm };
		}
		page.props.str.statuses.forEach((status) => {
			if (!types.value.some((e) => e.value == status.type)) {
				types.value.push({
					name: page.props.str.types[status.type],
					value: status.type,
				});
			}
		});
	});
</script>
